/**
 * formatCurrency - convert number or numeric string (1000) to comma separated number with ₹ symbol (₹1,000)
 *
 * @param value mandatory, number or numeric string to be converted
 * @param compactNotation optional, boolean to convert to compact notation, e.g. 1k, 1m
 * @param locale optional, string to define locale to which number will be converted e.g. en-IN, en-US
 * */
export const formatCurrency = (
  value: number | string,
  compactNotation: boolean = false,
  locale = "en-IN"
) => {
  if (!Number.isNaN(value)) {
    const roundVal = Number(value);
    const formatter = new Intl.NumberFormat(locale, {
      style: "currency",
      currency: "INR",
      minimumFractionDigits: 2,
      // @ts-ignore
      trailingZeroDisplay: "stripIfInteger",
      notation: compactNotation ? "compact" : "standard",
    });
    return roundVal >= 0 ? formatter.format(roundVal) : "-";
  } else {
    return "₹-";
  }
};

export default formatCurrency;
